module.exports = __webpack_public_path__ + "static/media/supps.0b4784f1.svg";